import { User, Luggage } from "lucide-react";
import { Reveal, ChapterHead } from "./Reveal";

const SEDAN_IMG =
  "https://images.unsplash.com/photo-1764090317825-9b76e437c8d8?crop=entropy&cs=srgb&fm=jpg&q=85";
const SUV_IMG =
  "https://images.unsplash.com/photo-1779025313068-b4a11d86bf0d?crop=entropy&cs=srgb&fm=jpg&q=85";
const CAB_IMG =
  "https://images.unsplash.com/photo-1601167936291-4e620b9894c2?crop=entropy&cs=srgb&fm=jpg&q=85";
const INTERIOR_IMG =
  "https://images.unsplash.com/photo-1780296269553-84ec2dd53065?crop=entropy&cs=srgb&fm=jpg&q=85";

const FLEET = [
  {
    img: SEDAN_IMG,
    name: "Executive Sedan",
    spec: ["4 passengers", "3 luggage"],
    note: "Corporate rides & airport runs",
    testid: "fleet-card-sedan",
  },
  {
    img: SUV_IMG,
    name: "Premium SUV",
    spec: ["6 passengers", "6 luggage"],
    note: "Premium airport express",
    testid: "fleet-card-suv",
  },
  {
    img: CAB_IMG,
    name: "ASAP Local Cab",
    spec: ["4 passengers", "2 luggage"],
    note: "The 3–7 minute workhorse",
    testid: "fleet-card-cab",
  },
];

export const Fleet = () => (
  <section id="fleet" className="relative py-24 sm:py-32 bg-ink-950/40">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <ChapterHead
        num="CHAPTER 02"
        kicker="The fleet"
        title="A reliable Sydney taxi service fleet, spotless inside out"
      />
      <div className="grid md:grid-cols-3 gap-5">
        {FLEET.map((car, i) => (
          <Reveal key={car.name} delay={i * 0.09}>
            <article
              data-testid={car.testid}
              className="group h-full bg-ink-800 border border-gold-400/10 rounded-2xl overflow-hidden transition-all duration-300 hover:border-gold-400/40 hover:-translate-y-1"
            >
              <div className="relative aspect-[16/10] overflow-hidden">
                <img
                  src={car.img}
                  alt={car.name}
                  loading="lazy"
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-[1.04]"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-ink-900 via-transparent to-transparent" />
              </div>
              <div className="p-6">
                <h3 className="font-display text-lg font-bold text-white mb-1">{car.name}</h3>
                <p className="text-xs text-[#99A1B3] mb-4">{car.note}</p>
                <div className="flex gap-4 font-mono text-[11px] text-gold-300">
                  <span className="flex items-center gap-1.5">
                    <User size={12} /> {car.spec[0]}
                  </span>
                  <span className="flex items-center gap-1.5">
                    <Luggage size={12} /> {car.spec[1]}
                  </span>
                </div>
              </div>
            </article>
          </Reveal>
        ))}
        <Reveal delay={0.28} className="md:col-span-3">
          <div className="relative rounded-2xl overflow-hidden border border-gold-400/10 group">
            <img
              src={INTERIOR_IMG}
              alt="Luxury taxi interior"
              loading="lazy"
              className="w-full h-64 md:h-72 object-cover transition-transform duration-700 group-hover:scale-[1.03]"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-ink-950/95 via-ink-950/60 to-transparent" />
            <div className="absolute inset-0 flex flex-col justify-center px-8 sm:px-12 max-w-xl">
              <h3 className="font-display text-xl sm:text-2xl font-extrabold text-white mb-2">
                Detailed daily. Inside and out.
              </h3>
              <p className="text-sm text-[#C9CFDC]">
                Every cab in the fleet is cleaned and inspected before shift start — because a
                reliable Sydney taxi service is judged on the last ride, not the first.
              </p>
            </div>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
